module.exports = __webpack_public_path__ + "img/me.6b2dbccc.svg";